/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SlimTransfer } from './SlimTransfer';
import {
    SlimTransferFromJSON,
    SlimTransferFromJSONTyped,
    SlimTransferToJSON,
} from './SlimTransfer';

/**
 * 
 * @export
 * @interface ListTransfersResponseBody
 */
export interface ListTransfersResponseBody {
    /**
     * 
     * @type {Array<SlimTransfer>}
     * @memberof ListTransfersResponseBody
     */
    items: Array<SlimTransfer>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListTransfersResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListTransfersResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListTransfersResponseBody interface.
 */
export function instanceOfListTransfersResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListTransfersResponseBodyFromJSON(json: any): ListTransfersResponseBody {
    return ListTransfersResponseBodyFromJSONTyped(json, false);
}

export function ListTransfersResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTransfersResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SlimTransferFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListTransfersResponseBodyToJSON(value?: ListTransfersResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(SlimTransferToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

